
export const env = {
    // Mode
    MODE: import.meta.env.MODE,
    DEV: import.meta.env.DEV,
    PROD: import.meta.env.PROD,

    // Firebase
    firebase: {
        apiKey: import.meta.env['VITE_FIREBASE_API_KEY'] || "AIzaSyAogkn-k79h1bVc_QNWrqrWOaKmd32Jlbw",
        authDomain: import.meta.env['VITE_FIREBASE_AUTH_DOMAIN'] || "wedora.app",
        projectId: import.meta.env['VITE_FIREBASE_PROJECT_ID'] || "webweddingplanner-b255a",
        storageBucket: import.meta.env['VITE_FIREBASE_STORAGE_BUCKET'] || "webweddingplanner-b255a.firebasestorage.app",
        messagingSenderId: import.meta.env['VITE_FIREBASE_MESSAGING_SENDER_ID'] || "583140331128",
        appId: import.meta.env['VITE_FIREBASE_APP_ID'] || "1:583140331128:web:717cfdf7bdf98afa00e78d",
        measurementId: import.meta.env.MODE === 'staging' ? undefined : (import.meta.env['VITE_FIREBASE_MEASUREMENT_ID'] || "G-7FB7KTQRKG")
    },

    // Stripe
    stripe: {
        essentialPriceId: import.meta.env['VITE_STRIPE_ESSENTIAL_PRICE_ID'],
        proPriceId: import.meta.env['VITE_STRIPE_PRO_PRICE_ID'],
        publishableKey: import.meta.env['VITE_STRIPE_PUBLISHABLE_KEY']
    },

    // Recaptcha
    recaptcha: {
        siteKey: import.meta.env['VITE_RECAPTCHA_SITE_KEY'],
        enterpriseKey: import.meta.env['VITE_RECAPTCHA_ENTERPRISE_KEY']
    },

    // API
    apiUrl: import.meta.env['VITE_API_URL'],

    // Google Maps
    googleMaps: {
        apiKey: import.meta.env['VITE_GOOGLE_MAPS_API_KEY']
    },

    // Weather
    weather: {
        openWeather: import.meta.env['VITE_OPENWEATHER_API_KEY'],
        tomorrow: import.meta.env['VITE_TOMORROW_API_KEY'],
        visualCrossing: import.meta.env['VITE_VISUAL_CROSSING_KEY']
    }
};

export default env;
